import { serverOnly$ } from "vite-env-only/macros";

import deAuth from "../locales/de/auth.json";
import deCart from "../locales/de/cart.json";
import deCheckout from "../locales/de/checkout.json";
import deClinic from "../locales/de/clinic.json";
import deCommon from "../locales/de/common.json";
import deDoctor from "../locales/de/doctor.json";
import deProduct from "../locales/de/product.json";
import deProfile from "../locales/de/profile.json";
import deVendor from "../locales/de/vendor.json";

import enAuth from "../locales/en/auth.json";
import enCart from "../locales/en/cart.json";
import enCheckout from "../locales/en/checkout.json";
import enClinic from "../locales/en/clinic.json";
import enCommon from "../locales/en/common.json";
import enDoctor from "../locales/en/doctor.json";
import enProduct from "../locales/en/product.json";
import enProfile from "../locales/en/profile.json";
import enVendor from "../locales/en/vendor.json";

import { type AvailableNamespaces, DEFAULT_NS } from "./i18n.constants";

export const supportedLngs = ["de", "en", "unknown"] as const;
export const fallbackLng = "en";
export const defaultNS = DEFAULT_NS;

type Resources = {
	[Lng in (typeof supportedLngs)[number]]: {
		[Ns in AvailableNamespaces]: Record<string, string>;
	};
};

export const resources = serverOnly$<Resources>({
	en: {
		common: enCommon,
		profile: enProfile,
		cart: enCart,
		checkout: enCheckout,
		auth: enAuth,

		product: enProduct,
		vendor: enVendor,
		doctor: enDoctor,
		clinic: enClinic,
	},
	de: {
		common: deCommon,
		profile: deProfile,
		cart: deCart,
		checkout: deCheckout,
		auth: deAuth,

		product: deProduct,
		vendor: deVendor,
		doctor: deDoctor,
		clinic: deClinic,
	},
	unknown: {
		common: objectKeysAsValues(deCommon),
		profile: objectKeysAsValues(deProfile),
		cart: objectKeysAsValues(deCart),
		checkout: objectKeysAsValues(deCheckout),
		auth: objectKeysAsValues(deAuth),

		product: objectKeysAsValues(deProduct),
		vendor: objectKeysAsValues(deVendor),
		doctor: objectKeysAsValues(deDoctor),
		clinic: objectKeysAsValues(deClinic),
	},
});

function objectKeysAsValues(obj: Record<string, string>) {
	return Object.fromEntries(Object.keys(obj).map((key) => [key, key]));
}
